import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'UnitDetail',
      component: resolve => require(['../components/UnitDetail.vue'], resolve),
      meta: {
        title: '企业信息'
      }
    },
    {
      path: '/invite',
      name: 'Invite',
      component: resolve => require(['../components/Invite.vue'], resolve),
      meta: {
        title: '邀请'
      }
    },
    {
      path: '/wedding',
      name: 'Wedding',
      component: resolve => require(['../components/Wedding.vue'], resolve),
      meta: {
        title: '请柬'
      }
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: resolve => require(['../components/Agreement.vue'], resolve),
      meta: {
        title: '服务协议'
      }
    },
    {
      path: '/userInfo',
      name: 'UserInfo',
      component: resolve => require(['../components/UserInfo.vue'], resolve),
      meta: {
        title: '用户信息'
      }
    },
    {
      path: '/getPhone',
      name: 'GetPhone',
      component: resolve => require(['../components/GetPhone.vue'], resolve),
      meta: {
        title: '绑定用户手机'
      }
    },
    {
      path: '/unbind',
      name: 'Unbind',
      component: resolve => require(['../components/Unbind.vue'], resolve),
      meta: {
        title: '解绑用户手机'
      }
    },
    {
      path: '/publicityContent',
      name: 'PublicityContent',
      component: resolve => require(['../components/PublicityContent.vue'], resolve),
      meta: {
        title: '专题宣传内容'
      }
    },
    {
      path: '/publicityDetail',
      name: 'PublicityDetail',
      component: resolve => require(['../components/PublicityDetail.vue'], resolve),
      meta: {
        title: '专题宣传内容详情'
      }
    },
    {
      path: '/dutyList',
      name: 'DutyList',
      component: resolve => require(['../components/DutyList.vue'], resolve),
      meta: {
        title: '专题宣传内容'
      }
    },
    {
      path: '/readRank',
      name: 'ReadRank',
      component: resolve => require(['../components/ReadRank.vue'], resolve),
      meta: {
        title: '查看统计'
      }
    },
    {
      path: '/unitFireFightingKeynote',
      name: 'UnitFireFightingKeynote',
      component: resolve => require(['../components/UnitFireFightingKeynote.vue'], resolve),
      meta: {
        title: '消防重点部位'
      }
    },
    {
      path: '/specialInspection',
      name: 'SpecialInspection',
      component: resolve => require(['../components/SpecialInspection.vue'], resolve),
      meta: {
        title: '专项检查问题'
      }
    },
    {
      path: '/anyTimeReport',
      name: 'AnyTimeReport',
      component: resolve => require(['../components/AnyTimeReport.vue'], resolve),
      meta: {
        title: '随手报'
      }
    },
    {
      path: '/specialInspectionDetail',
      name: 'SpecialInspectionDetail',
      component: resolve => require(['../components/SpecialInspectionDetail.vue'], resolve),
      meta: {
        title: '问题详情'
      }
    },
    {
      path: '/specialInspectionHistory',
      name: 'SpecialInspectionHistory',
      component: resolve => require(['../components/SpecialInspectionHistory.vue'], resolve),
      meta: {
        title: '历史问题'
      }
    },
    {
      path: '/unitFireFightingKeynoteDetail',
      name: 'UnitFireFightingKeynoteDetail',
      component: resolve => require(['../components/UnitFireFightingKeynoteDetail.vue'], resolve),
      meta: {
        title: '重点部位详情'
      }
    },
    {
      path: '/anyTimeReportDetail',
      name: 'AnyTimeReportDetail',
      component: resolve => require(['../components/AnyTimeReportDetail.vue'], resolve),
      meta: {
        title: '随手报详情'
      }
    },
    {
      path: '/autoProblemAdd',
      name: 'AutoProblemAdd',
      component: resolve => require(['../components/AutoProblemAdd.vue'], resolve),
      meta: {
        title: '立即上报'
      }
    },
    {
      path: '/faultReport',
      name: 'FaultReport',
      component: resolve => require(['../components/FaultReport.vue'], resolve),
      meta: {
        title: '故障上报首页'
      }
    },
    {
      path: '/maintainHistory',
      name: 'MaintainHistory',
      component: resolve => require(['../components/MaintainHistory.vue'], resolve),
      meta: {
        title: '报修历史'
      }
    },
    {
      path: '/maintainHistoryDetail',
      name: 'MaintainHistoryDetail',
      component: resolve => require(['../components/MaintainHistoryDetail.vue'], resolve),
      meta: {
        title: '报修历史详情'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js